var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogoutImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.772,
    height: 22.004,
    viewBox: "0 0 22.772 22.004",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.772 22.004) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,5.714H10.439L7.8,8.1,9.079,9.518l5.263-4.76L9.079,0,7.8,1.416,10.439,3.8H0Z",
    transform: "translate(0 6.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.573,0H0V4.658H1.91V1.91H16.664V20.095H1.91V17.3H0V22H18.573Z",
    transform: "translate(4.199)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoutImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logoutImg.6aee96e1.svg";
export { ForwardRef as ReactComponent };